import { AxiosPromise, AxiosStatic } from "axios";
import {
  ActivityDistributionDetail,
  CommitmentActivity,
  EarningsDestinations,
} from "../types/CommitmentActivity";

export const getCommitmentActivity =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (commitmentId: string): AxiosPromise<CommitmentActivity> =>
    await appAxios.get(
      `${serverURL}/commitments-v2/${commitmentId}/activity`,
      { withCredentials: true }
    );

export const getDistributionDetail =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    commitmentId: string,
    distributionId: string
  ): AxiosPromise<ActivityDistributionDetail> =>
    await appAxios.get(
      `${serverURL}/commitments-v2/${commitmentId}/activity/distributions/${distributionId}`,
      { withCredentials: true }
    );

export const getEarningsDestinations =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (commitmentId: string): AxiosPromise<EarningsDestinations> =>
    await appAxios.get(
      `${serverURL}/commitments-v2/${commitmentId}/earnings-destinations`,
      { withCredentials: true }
    );

export const setEarningsDestination =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    commitmentId: string,
    destinationDealId: string
  ): AxiosPromise<EarningsDestinations> =>
    await appAxios.put(
      `${serverURL}/commitments-v2/${commitmentId}/earnings-destination`,
      { destinationDealId },
      { withCredentials: true }
    );
